import { Message, Loading } from "element-ui";
import api from '@/api/api';
import axios from 'axios'
const util = {
    $error(message) {
        Message({
            showClose: false,
            message: message,
            type: 'error'
        });
    },
    $warning(message) {
        Message({
            showClose: false,
            message: message,
            type: 'warning'
        });
    },
    $success(message) {
        Message({
            showClose: false,
            message: message,
            type: 'success'
        });
    },
    $mloading(message) {
        Loading({
            lock: true,
            text: message,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
    },
    $loadingClose() {
        Loading.close();
    },
    getTimestamp(time) {
        return (new Date(time)).getTime()
    },
    getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg)){
            return unescape(arr[2]);
        }else{
            return null;
        }
    },
    setCookie(cookiename, cookievalue, hours) {
        var date = new Date();
        date.setTime(date.getTime() + Number(hours) * 3600 * 1000);
        document.cookie = cookiename + "=" + cookievalue + "; path=/;expires = " + date.toGMTString(); 
    },
	getDecodeCookie(name){
	    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
	    if(arr=document.cookie.match(reg)){
	        return decodeURI(decodeURI(unescape(arr[2])));
	    }else{
	        return null;
	    }
	},
	setEncodeCookie(cookiename, cookievalue, hours) {
	    var date = new Date();
	    date.setTime(date.getTime() + Number(hours) * 3600 * 1000);
	    document.cookie = cookiename + "=" + encodeURI(encodeURI(cookievalue)) + "; path=/;expires = " + date.toGMTString(); 
	},
	timeFormat(dateVal,type) {
		dateVal = dateVal.toString().length == 10 ? dateVal * 1000 : dateVal
	    let time = new Date(dateVal);
	    let year = time.getFullYear();
	    let month = time.getMonth() + 1 >= 10 ? time.getMonth() + 1 : '0' + (time.getMonth() + 1);
	    let day = time.getDate() >= 10 ? time.getDate() : "0" + time.getDate();
	    let hour = time.getHours() >= 10 ? time.getHours() : "0" + time.getHours();
	    let minu = time.getMinutes() >= 10 ? time.getMinutes() : "0" + time.getMinutes();
		let second = time.getSeconds() >= 10 ? time.getSeconds() : "0" + time.getSeconds();
		if(type == 'day'){
			return year + "-" + month + "-" + day;
		}else if(type == 'dayChina'){
			return year + "年" + month + "月" + day + '日’';
		}else if(type == 'second'){
			return year + "-" + month + "-" + day + " " + hour + ":" + minu + ":" + second;
		}else{
			return year + "-" + month + "-" + day + " " + hour + ":" + minu
		}
	},
}
export default util


// WEBPACK FOOTER //
// ./src/utils/util.js